import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_PATH_KEY } from '@/swagger/constants/credits-keys';
import {
  API_GET_DEPARTMENTS_CREDITS_QUARTER,
  KEY_GET_DEPARTMENTS_CREDITS_QUARTER,
} from '../constants';
import { MOCK_RESPONSE_GET_DEPARTMENTS_CREDITS_QUARTER } from '../mocks';

type RequestGetDepartmentsCreditsQuarter = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_PATH_KEY
>['request']['path'];

export type ResponseGetDepartmentsCreditsQuarter = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_PATH_KEY
>['response']['body'];

export type CallParamsGetDepartmentsCreditsQuarter = Omit<
  RequestGetDepartmentsCreditsQuarter,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetDepartmentsCreditsQuarter = ResponseGetDepartmentsCreditsQuarter;

type CallErrorGetDepartmentsCreditsQuarter = {
  message: string;
  code: number;
};

type CallSelectorsGetDepartmentsCreditsQuarter = {
  defaultQuarter?: string;
};

export const getDepartmentsCreditsQuarterCall = createGeneralCall<
  CallParamsGetDepartmentsCreditsQuarter,
  CallResponseGetDepartmentsCreditsQuarter,
  CallErrorGetDepartmentsCreditsQuarter,
  CallSelectorsGetDepartmentsCreditsQuarter
>({
  id: KEY_GET_DEPARTMENTS_CREDITS_QUARTER,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_DEPARTMENTS_CREDITS_QUARTER(org as unknown as string, payload.departmentId);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_DEPARTMENTS_CREDITS_QUARTER : undefined,
  selectors: {
    defaultQuarter: ({ selectors }) =>
      createSelector(
        selectors.response,
        res => (res && res.length > 0 && `${res[0].quarter}-${res[0].year}`) || undefined,
      ),
  },
});
